import { BusyIndicator, generateUUID, LocalTransformFacet } from "flavr-common";
import { modelPool } from "@modules/model";
export class ToolBeltLoadingSpinner {
    constructor(parent) {
        this.parent = parent;
    }
    isActive() { return this.spinnerModel !== undefined; }
    create(pos) {
        if (this.spinnerModel !== undefined)
            return;
        this.spinnerModel = modelPool.createModel(`___ToolSpinner_${generateUUID()}`, this.parent);
        this.spinnerModel.setFacet(new BusyIndicator());
        this.spinnerModel.setFacet(new LocalTransformFacet(pos, undefined, [0.1, 0.1, 0.1]));
    }
    destroy(delayMilliseconds) {
        if (this.spinnerModel === undefined)
            return;
        if (delayMilliseconds !== undefined) {
            setTimeout(() => {
                if (this.spinnerModel === undefined)
                    return;
                modelPool.destroyModel(this.spinnerModel.getUID(), { destroyPermanently: true });
                this.spinnerModel = undefined;
            }, delayMilliseconds);
        }
        else {
            modelPool.destroyModel(this.spinnerModel.getUID(), { destroyPermanently: true });
            this.spinnerModel = undefined;
        }
    }
}
